import React, { createContext, useState, useContext } from 'react';

// Initial Mock Data
const INITIAL_SERVICES = [
  {
    id: 'svc_1',
    name: 'MH Rental Agreement',
    state: 'Maharashtra',
    article: 'Leave and License',
    basePrice: 500,
    platformFee: 50,
    vendorId: 'vendor_1',
    isEnabled: true,
    fixedFields: {
      article: true,
      denomination: true
    },
    defaultValues: {
      article: 'Leave and License',
      denomination: 100
    }
  }
];

const INITIAL_WALLET_BALANCE = 5000;

const MockDataContext = createContext();

export const MockDataProvider = ({ children }) => {
  const [currentUserRole, setCurrentUserRole] = useState('admin'); // 'admin', 'client', 'vendor'
  const [services, setServices] = useState(INITIAL_SERVICES);
  const [orders, setOrders] = useState([]);
  const [walletBalance, setWalletBalance] = useState(INITIAL_WALLET_BALANCE);

  // Helper actions
  const addService = (newService) => {
    setServices([...services, newService]);
  };

  const toggleService = (id) => {
    setServices(services.map(s => s.id === id ? { ...s, isEnabled: !s.isEnabled } : s));
  };

  const placeOrder = (order) => {
    const totalCost = order.quantity * (order.unitPrice + order.platformFee);
    if (walletBalance < totalCost) return { success: false, message: 'Insufficient Funds' };
    
    setWalletBalance(prev => prev - totalCost);
    setOrders([order, ...orders]);
    return { success: true };
  };

  const updateOrderStatus = (orderId, status, meta = {}) => {
    setOrders(orders.map(o => o.id === orderId ? { ...o, status, ...meta } : o));
  };

  const addFunds = (amount) => {
    setWalletBalance(prev => prev + amount);
  };

  return (
    <MockDataContext.Provider value={{
      currentUserRole,
      setCurrentUserRole,
      services,
      addService,
      toggleService,
      orders,
      placeOrder,
      updateOrderStatus,
      walletBalance,
      addFunds
    }}>
      {children}
    </MockDataContext.Provider>
  );
};

export const useMockData = () => useContext(MockDataContext);
